/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHotelHotelSellReportChangeObservedPost } from '../fn/change-observed-endpoint/api-hotel-hotel-sell-report-change-observed-post';
import { ApiHotelHotelSellReportChangeObservedPost$Params } from '../fn/change-observed-endpoint/api-hotel-hotel-sell-report-change-observed-post';
import { StatusedBasedResponseInfoResultApiResult } from '../models/statused-based-response-info-result-api-result';

import { environment } from '@environments/environment';
import { Saver, SAVER } from '@donstudio/ds/_tokens';
import { download } from '@donstudio/shared/file-export';

@Injectable({ providedIn: 'root' })
export class ChangeObservedEndpointService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient,
    @Inject(SAVER) private save: Saver,) {
    super(config, http);
  }

  /** Path part for operation `apiHotelHotelSellReportChangeObservedPost()` */
  static readonly ApiHotelHotelSellReportChangeObservedPostPath = '/api/hotel/HotelSellReport/ChangeObserved';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHotelHotelSellReportChangeObservedPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelHotelSellReportChangeObservedPost$Response(params: ApiHotelHotelSellReportChangeObservedPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusedBasedResponseInfoResultApiResult>> {
    return apiHotelHotelSellReportChangeObservedPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHotelHotelSellReportChangeObservedPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiHotelHotelSellReportChangeObservedPost(params: ApiHotelHotelSellReportChangeObservedPost$Params, context?: HttpContext): Observable<StatusedBasedResponseInfoResultApiResult> {
    return this.apiHotelHotelSellReportChangeObservedPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<StatusedBasedResponseInfoResultApiResult>): StatusedBasedResponseInfoResultApiResult => r.body)
    );
  }

  getVoucherBySellId(sellId: number, filename = 'report') {
    return this.http.post(`${environment.apiUrl}/api/hotel/getVoucherBySellId`,
      {
        sellId,
      },
      {
        headers: {
          accept: 'octet-stream/pdf'
        },
        reportProgress: true,
        observe: 'events',
        responseType: 'blob'
      }
    ).pipe(
      tap((res) => {
        if ('headers' in res) {
          filename = decodeURIComponent(res.headers.get('content-disposition')?.split("''").pop()!);
        }
      }),
      download(blob => {
        return this.save(blob, filename)
      })
    );
  }
}
